/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class NotificationHeader extends React.Component {
	constructor(props) {
		super(props);

		this.clearAllNotices = this.clearAllNotices.bind(this);

	}

	clearAllNotices(e) {

		e.preventDefault();
		this.props.clearNotices();

	}

	render() {
		return (
			<div className="notification-header">
				<div className="notification-header-label">
					{ this.props.count } Notifications
				</div>
				<div className="notification-header-actions" onTouchStart={this.clearAllNotices} onClick={this.clearAllNotices}>
					Mark all as read
				</div>
			</div>
		);
	}

};

NotificationHeader.propTypes = {
	count: PropTypes.number
};

NotificationHeader.defaultProps = {
    count: 0
};


export default NotificationHeader;
